// 公司管理
import {contractApi} from "@/axios";
//获取公司信息
export function getCompanyPage(params,sendData){
    return contractApi({
        url:'/businessInformation/page',
        method:'post',
        data:sendData,
        params:params
    })
}
//删除公司信息
export function deleteCompany(params){
    return contractApi({
        url:'/businessInformation',
        method:'delete',
        params:params
    })
}
//添加公司信息
export function addCompany(data){
    return contractApi({
        url:'/businessInformation',
        method:'post',
        data:data
    })
}
//修改公司信息
export function editCompany(data){
    return contractApi({
        url:'/businessInformation',
        method:'put',
        data:data
    })
}
//下载附件
export function attachmentCompany(id) {
    return contractApi({
        url: '/businessInformation/attachment/' + id,
        method: 'get',
        responseType: 'blob', // 设置响应类型为 blob
    });
}
//更新公司开票状态
export function updateStatus(id,status){
    return contractApi({
        url:'/businessInformation/update-status/'+id+'/'+status,
        method:'put'
    })
}
//绑定负责人
export function bindCharge(data){
    return contractApi({
        url:'/businessInformation/bind-company-charge',
        method:'put',
        data:data
    })
}
//更新公司三方报价状态
export function updateThreePartyStatus(id, status) {
    return contractApi({
        url: '/businessInformation/update-three-party-status/' + id + '/' + status,
        method: 'put'
    })
}